module.exports = __webpack_public_path__ + "img/symbol_2.7b27ff15.png";